var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
var MessagePopupComponent = /** @class */ (function (_super) {
    __extends(MessagePopupComponent, _super);
    function MessagePopupComponent() {
        return _super.call(this) || this;
    }
    return MessagePopupComponent;
}(AchooPopupComponent));
export { MessagePopupComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/message-popup/message-popup.component.ts.pre-build-optimizer.js